/**
 * Retourner sa caméra en pleine séance (Wajih, 21/10 : une fonction perdue, à remettre) : la règle pure
 * du choix de l'autre caméra. Les crochets la branchent (`useCameraFlip`, natif et web).
 *
 * L'ancien bouton (`useSwitchCamera`, le natif) passait de l'avant à l'arrière, et retour. Ici : vers une
 * caméra tournée de l'autre côté quand on sait de quel côté chacune regarde, sinon vers la suivante de la
 * liste (deux webcams d'un ordinateur). Une seule caméra : rien à retourner, et rien ne s'offre.
 */

/** De quel côté une caméra regarde, quand on le sait. */
export type CameraSide = "front" | "back" | null

export type FlipCamera = { id: string; side: CameraSide }

/** Ce que l'écran reçoit : le geste, seulement quand une autre caméra est là. */
export type CameraFlip = { flip: () => void }

// Les noms que les navigateurs donnent : « Back Camera », « camera2 0, facing back », « Caméra arrière ».
const BACK_LABEL = /\b(back|rear|environment)\b|arri[eè]re/i
const FRONT_LABEL = /\b(front|user|facetime)\b|avant/i

/** Le côté d'une caméra lu sur son nom (le web : le navigateur ne le dit pas autrement sans droits). */
export function cameraSideOfLabel(label: string): CameraSide {
    if (BACK_LABEL.test(label)) return "back"
    if (FRONT_LABEL.test(label)) return "front"
    return null
}

/**
 * La caméra vers laquelle retourner, depuis l'active (`null` quand on ne sait pas laquelle l'est : la
 * première de la liste fait foi, comme la salle qui ouvre celle du système). `null` : une seule caméra.
 */
export function nextCameraId(cameras: readonly FlipCamera[], activeId: string | null): string | null {
    if (cameras.length < 2) return null
    const index = Math.max(
        0,
        cameras.findIndex((camera) => camera.id === activeId)
    )
    const active = cameras[index]
    if (active.side != null) {
        const other = cameras.find((camera) => camera.side != null && camera.side !== active.side)
        if (other != null) return other.id
    }
    return cameras[(index + 1) % cameras.length].id
}
